import { render, staticRenderFns } from "./base_select.vue?vue&type=template&id=2f5cf587&"
import script from "./base_select.vue?vue&type=script&lang=js&"
export * from "./base_select.vue?vue&type=script&lang=js&"
import style0 from "./base_select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports